export const VEHICLE_SIZES = [
  { value: "standard", label: "Standard car" },
  { value: "large_suv", label: "Large SUV / 4x4" },
  { value: "small_van", label: "Small van" },
  { value: "medium_van", label: "Medium van" },
  { value: "large_van", label: "Large van" },
  { value: "other", label: "Other (custom quote)" },
];

export const CONDITIONS = [
  { value: "runner", label: "Runner" },
  { value: "non_runner_rolling", label: "Non-runner — wheels roll freely" },
  { value: "non_runner_seized", label: "Non-runner — wheels / gearbox seized" },
];

export const LOWERED = [
  { value: "no", label: "No" },
  { value: "yes", label: "Yes" },
  { value: "not_sure", label: "Not sure" },
];

export const TIME_SLOTS = [
  { value: "flexible", label: "Flexible / Any time" },
  { value: "day", label: "08:00 – 18:00" },
  { value: "early", label: "05:00 – 08:00" },
  { value: "evening", label: "18:00 – 21:00" },
  { value: "late", label: "21:00 – 00:00" },
  { value: "overnight", label: "00:00 – 05:00" },
];

export const FLEX = [
  { value: "none", label: "Keep my requested time" },
  { value: "same_day", label: "Same day, flexible time" },
  { value: "plus_minus_1", label: "±1 day" },
  { value: "plus_minus_3", label: "±3 days" },
];

export const ACCESS = [
  { value: "yes", label: "Yes" },
  { value: "no", label: "No" },
  { value: "not_sure", label: "Not sure" },
];

export const CONTACT_METHODS = [
  { value: "phone", label: "Phone" },
  { value: "whatsapp", label: "WhatsApp" },
  { value: "email", label: "Email" },
];

export const AUCTION_FACILITIES = [
  { value: "", label: "— Select facility —" },
  { value: "Copart", label: "Copart" },
  { value: "SYNETIQ", label: "SYNETIQ" },
  { value: "BCA", label: "BCA" },
  { value: "Manheim", label: "Manheim" },
  { value: "Other", label: "Other" },
];

export const emptyQuote = () => ({
  vehicle: {
    registration: "",
    make: "",
    model: "",
    year: "",
    fuel: "",
    body_type: "",
    vehicle_size: "standard",
  },
  condition: "runner",
  lowered: "no",
  journey: {
    pickup_location: "",
    dropoff_location: "",
    miles: 0,
  },
  collection: {
    date: "",
    time_slot: "flexible",
    flexibility: "none",
  },
  access: {
    collection_access: "yes",
    delivery_access: "yes",
  },
  auction: {
    is_auction: false,
    facility: "",
    reference: "",
  },
  notes: "",
  customer: {
    name: "",
    phone: "",
    email: "",
    preferred_contact: "phone",
  },
  marketing_consent: false,
  terms_accepted: false,
});
